export default {
  name: 'marking--remarkH',
  apiService: 'shoes',
  apiPath: '/admin/remark_h',
};